import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import urls from "../../../config/urls.json";
import { useSession } from "../../../hooks/useSession";
import { useStates } from "../../../hooks/useStates";
import { ApiService as api } from "../../../services/ApiService";
import moment from "moment";
// import { useCodiceFiscalePage } from "../CodiceFiscalePage/useCodiceFiscalePage";
import { useDynatrace } from "../../../hooks/useDynatrace";
import useLog from "../../../hooks/useLog";

export const useFilialiPage = () => {
    const { branchSelectionEvent} = useLog();

    const [currentMapToShow, setCurrentMapToShow] = useState("");

    const navigate = useNavigate();
    const { read, update, batchUpdate, canISkipCfPage } = useSession();
    const { states, setCurrentState, isFilialiSlideBusy, isCfPageReady } = useStates();
    // const { nextForExternalCf } = useCodiceFiscalePage();

    const [fetchError, setFetchError] = useState(false);
    const [fetchErrorMessage, setFetchErrorMessage] = useState("");

    let subSlider = useRef();
    let daySlider = useRef();

    useEffect(() => {
        setCurrentState(states.LOAD_FILIALI_SLIDES_END);
    }, []);

    const {} = useDynatrace();

    const hasValidUserData = () => {
        let valid = true;
        const nome = read("nome");
        const cognome = read("cognome");
        const email = read("email");
        const telefono = read("telefono") || read("cellulare");
        const cap = read("cap") || read("capResidenza") || read("cap_utente");
        if (!nome || nome == "") {
            valid = false;
        }
        if (!cognome || cognome == "") {
            valid = false;
        }
        if (!email || email == "") {
            valid = false;
        }
        if (!telefono || telefono == "") {
            valid = false;
        }
        if (!cap || cap == "") {
            valid = false;
        }
        return valid;
    };

    const next = () => {
        branchSelectionEvent();

        if (read("cap_utente") == "" && read("cap") != "" && true == read("utenteRiconosciuto")) {
            update("cap_utente", read("cap"));
        }
        if (true == read("ricontattoCf") && true == read("ricontattoLuogo")) {
            update("ricontatto", true);
            navigate(urls.clink.path);
        } else if (true == read("utenteRiconosciuto") && hasValidUserData()) {
            navigate(urls.datiPersonaliRiconosciutoC5.path);
        } else {
            navigate(urls.datiPersonaliNonRiconosciutoC5.path);
        }
    };

    const onFilialiSlideChange = async (filialeIdx) => {
        setCurrentState(states.LOAD_FILIALI_SLIDES_START);
        const filiale = read("filiali")[filialeIdx];
        batchUpdate({
            filialeScelta: filiale,
            disponibilita: filiale.days,
            dataScelta: filiale.days[0],
        });
        // force change on giorniSlider to automate call to Disponibilita
        onGiorniSlideChange(0);
        if (daySlider && daySlider.current) daySlider.current.go(0);
    };

    const onGiorniSlideChange = async (giornoIdx) => {
        setCurrentState(states.LOAD_FILIALI_SLIDES_START);
        const dataObj = read("disponibilita")[giornoIdx];
        update("dataScelta", dataObj);

        // call new Disponibilita
        let disponibilitaResult = {};
        try {
            disponibilitaResult = await api.GetDayAndTimeSlot({
                IdFiliale: read("filialeScelta").codFiliale,
                From: moment().toDate(),
                To: moment().add(7, "days").toDate(),
            });
        } catch (error) {
            setFetchErrorMessage("C'è stato un errore nel caricamento delle disponibilità delle filiali. <br />Per favore riprova.");
            setFetchError(true);
            return;
        }

        let orariDisponibili;
        const slots = disponibilitaResult.Slots || [];
        for (let day of slots) {
            const slotDay = moment(day.Date).format("MM-DD");
            const requestDay = moment(dataObj.data).format("MM-DD");
            if (slotDay == requestDay) {
                orariDisponibili = day.Time;
            }
        }
        const orari = [
            { hour: 9, minute: 0, disponibile: false },
            { hour: 9, minute: 30, disponibile: false },
            { hour: 10, minute: 0, disponibile: false },
            { hour: 10, minute: 30, disponibile: false },
            { hour: 11, minute: 0, disponibile: false },
            { hour: 11, minute: 30, disponibile: false },
            { hour: 12, minute: 0, disponibile: false },
            { hour: 12, minute: 30, disponibile: false },
            { hour: 14, minute: 0, disponibile: false },
            { hour: 14, minute: 30, disponibile: false },
            { hour: 15, minute: 0, disponibile: false },
            { hour: 15, minute: 30, disponibile: false },
            { hour: 16, minute: 0, disponibile: false },
            { hour: 16, minute: 30, disponibile: false },
            { hour: 17, minute: 0, disponibile: false },
            { hour: 17, minute: 30, disponibile: false },
        ];
        for (let t in orariDisponibili) {
            const orarioDisponibile = orariDisponibili[t];
            const ora = orarioDisponibile.split(":")[0];
            const minuto = orarioDisponibile.split(":")[1];
            for (let o in orari) {
                if (orari[o].hour == ora && orari[o].minute == minuto) {
                    orari[o].disponibile = true;
                }
            }
        }

        update("orari", orari);

        let favouriteHour = orari.filter((_) => _.disponibile == true)[0];
        const eligibleOrarioScelto = orari.filter((_) => {
            const orarioScelto = read("orarioScelto");
            if (orarioScelto) {
                return _.disponibile == true && _.hour == orarioScelto.hour && _.minute == orarioScelto.minute;
            } else {
                return false;
            }
        });
        if (eligibleOrarioScelto.length > 0) {
            favouriteHour = eligibleOrarioScelto[0];
        }

        update("orarioScelto", favouriteHour);
        setCurrentState(states.LOAD_FILIALI_SLIDES_END);
    };

    const showMap = (id, coords) => {
        if (currentMapToShow.length) {
            setCurrentMapToShow("");
            destroyMap(id);
        } else {
            setCurrentMapToShow(id);
            renderMap(id, coords);
        }
    };
    const renderMap = (id, coords) => {
        const appleMapManager = window.AppleMapManager();
        appleMapManager.renderMap(id, {
            latitude: coords.lat,
            longitude: coords.lng,
        });
    };
    const destroyMap = (id) => {
        setTimeout(() => {
            const mapNode = document.getElementById(id);
            mapNode.innerHTML = "";
        }, 500);
    };

    return {
        next,
        read,
        update,
        subSlider,
        daySlider,
        onFilialiSlideChange,
        onGiorniSlideChange,
        isFilialiSlideBusy,
        isCfPageReady,
        showMap,
        currentMapToShow,
        fetchErrorMessage,
        fetchError,
        setFetchError,
    };
};
